import LinkAccountFormControl from 'purchase/checkout/linkAccount/LinkAccountFormControl';
import linkAccountModel from 'purchase/checkout/linkAccount/linkAccountModel';
// eslint-disable-next-line import/no-cycle
import {
	getUrl,
	handleResponse,
	showSpinner,
} from 'purchase/checkout/linkAccount/linkAccountUtility';

export default () => {
	const linkAccountForm = document.getElementById('customerAccountLinkForm');
	const findAccountBtn = document.getElementById(
		'customerLinkAccountFormModalActionLink',
	);
	if (linkAccountForm && findAccountBtn) {
		const linkAccountFormControl = new LinkAccountFormControl(linkAccountForm);
		findAccountBtn.addEventListener('click', () =>
			findAccount(linkAccountFormControl),
		);
	}
};

export const findAccount = linkAccountFormControl => {
	if (linkAccountFormControl.validateForm()) {
		showSpinner();
		const button = document.querySelector(
			'[data-id="customerLinkAccountFormModalActionLink"]',
		);
		button.setAttribute('disabled', 'disabled');
		const formData = getFormData();
		const url = getUrl('customerAccountLinkForm');
		return linkAccountModel(formData, url)
			.then(handleResponse)
			.catch(() => null);
	}
	return undefined;
};

const getFormData = () => {
	const formData = {};
	const formNode = document.getElementById('customerAccountLinkForm');
	if (!formNode) {
		throw new ReferenceError('Customer account link form does not exist');
	}
	const formInputs = Array.from(formNode.querySelectorAll('input'));
	formInputs.forEach(input => {
		formData[input.name] = input.value;
	});
	return formData;
};
